<mat-horizontal-stepper linear="false" #stepper (selectionChange)="changeStepper($event, stepper)">
  <mat-step [completed]="isFirstStepCompleted" [hasError]="firstStepError">
    <ng-template matStepLabel>{{ 'request.matStepLabel1' | translate }}</ng-template>

    <scf-point-of-sale
      [mode]="mode"
      [request]="request"
      (vendor)="updateCombosVendor($event)"
      [state]="state"
      [isMG]="false"
      [isMgWithShopping]="false"
      [isBP]="false"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (establishment)="updateCombos($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    >
    </scf-point-of-sale>
    <scf-prescriber-contact-data
      [mode]="mode"
      [isAutos]="true"
      [request]="request"
      [state]="state"
      [vendor]="vendor"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (changeContinueStatus)="changeContinueStatusForms($event)"
    >
    </scf-prescriber-contact-data>
    <scf-request-data-autos
      [establishment]="establishment"
      [vendor]="vendor"
      [mode]="mode"
      [state]="state"
      [isEditAutos]="isEditAutos"
      [request]="request"
      [expirationMonth]="expirationMonth"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (sendDataFinance)="openCalculateFinance($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      (changeValue)="changeValueClearTable($event)"
    >
    </scf-request-data-autos>
    <scf-request-finance
      *ngIf="mode !== 'view'"
      [establishment]="establishment"
      [hidden]="clearTable"
      [mode]="mode"
      [request]="request"
      [dataCallSimulation]="dataFinance"
      [isCalculator]="false"
      [changing]="changingValueClearTable"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (changeExpiredMonth)="setExpiredMonth($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-finance>
    <scf-request-basic-contact
      hidden
      [mode]="mode"
      [state]="state"
      [request]="request"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-basic-contact>

    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button
          id="clearFieldsButtonFirstStepAutos"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button id="nextStepButtonFirstStepAutos" mat-flat-button color="accent" matStepperNext>
          {{ 'request.matStepperNext' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [completed]="isSecondStepCompleted" [hasError]="secondStepError">
    <ng-template matStepLabel>{{ 'request.matStepLabel2' | translate }}</ng-template>
    <scf-holder-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-holder-data>
    <scf-contact-data
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isAuto]="true"
      [isConsumption]="false"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-contact-data>
    <scf-socioeconomic-data
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
      [mode]="mode"
      [request]="request"
      [state]="state"
      [isMgWithShopping]="false"
      [isBP]="false"
      [isMG]="false"
      [isAuto]="true"
      [isConsumo]="false"
    ></scf-socioeconomic-data>

    <div class="btnLeft">
      <button
        id="addIntervinentButtonAutos"
        class="request__interviniente request__btnIntervinientes--add"
        color="primary"
        mat-flat-button
        (click)="addIntervinente(1)"
        *ngIf="mode !== 'view' && this.intervinientes.length === 0"
      >
        <mat-icon class="icon-ic_add_circle_outline"></mat-icon>
        <mat-label [translate]="'request.addIntervinent'"> </mat-label>
      </button>
    </div>
    <!-- INTERVINIENTES -->
    <div *ngFor="let interviniente of intervinientes; let i = index; let last = last">
      <div class="btnLeft">
        <button
          id="deleteIntervinentButtonAutos"
          *ngIf="
            mode !== 'view' &&
            (state?.id === PENDIENTES_DE_DATOS || mode === 'new' || this.newParticipants.includes(interviniente.id))
          "
          class="request__interviniente request__btnIntervinientes--delete"
          mat-stroked-button
          (click)="deleteInterviniente(interviniente)"
        >
          <mat-icon class="icon-ic_remove_circle_outline"></mat-icon>
          <mat-label [translate]="'request.deleteIntervinent'"> </mat-label>
        </button>
      </div>

      <div>
        <scf-holder-data
          [mode]="mode"
          [numInterviniente]="i + 1"
          [request]="interviniente.request"
          [state]="state"
          [interviniente]="interviniente"
          (changeContinueStatus)="changeContinueStatusForms($event)"
          (disabledOwnershipCombo)="disabledOwnershipCombo($event)"
        ></scf-holder-data>
        <scf-contact-data
          [mode]="mode"
          [numInterviniente]="i + 1"
          [request]="interviniente.request"
          [state]="state"
          [interviniente]="interviniente"
          [isAuto]="true"
          [isConsumption]="false"
          (changeContinueStatus)="changeContinueStatusForms($event)"
        >
        </scf-contact-data>
        <scf-socioeconomic-data
          [mode]="mode"
          [numInterviniente]="i + 1"
          [request]="interviniente.request"
          [state]="state"
          [interviniente]="interviniente"
          [isMgWithShopping]="false"
          [isBP]="false"
          [isMG]="false"
          [isAuto]="true"
          [isConsumo]="false"
          (changeContinueStatus)="changeContinueStatusForms($event)"
        ></scf-socioeconomic-data>
      </div>

      <div class="btnLeft">
        <button
          id="addNextIntervinentButtonAutos"
          class="request__interviniente request__btnIntervinientes--add"
          color="primary"
          mat-flat-button
          (click)="addIntervinente(this.intervinientes.length + 1)"
          *ngIf="mode !== 'view' && this.intervinientes.length < 3 && last"
        >
          <mat-icon class="icon-ic_add_circle_outline"></mat-icon>
          <mat-label [translate]="'request.addIntervinent'"> </mat-label>
        </button>
      </div>
    </div>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button id="previousStepButtonSecondStepAutos" mat-flat-button color="accent" matStepperPrevious>
          {{ 'request.matStepperPrevious' | translate | uppercase }}
        </button>
        <button
          id="clearFieldsButtonSecondStepAutos"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button
          id="saveButtonSecondStepAutos"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button id="nextStepButtonSecondStepAutos" mat-flat-button color="accent" matStepperNext>
          {{ 'request.matStepperNext' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [completed]="isThirdStepCompleted" [hasError]="thirdStepError">
    <ng-template matStepLabel>{{ 'request.matStepLabel3' | translate }}</ng-template>
    <scf-direct-debit
      [mode]="mode"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-direct-debit>
    <!-- INTERVINIENTES -->
    <div *ngFor="let interviniente of intervinientes; let i = index; let last = last">
      <scf-direct-debit
        [mode]="mode"
        [state]="state"
        [numInterviniente]="i + 1"
        [disabledOwnershipCombo]="disabledOwnership"
        [request]="interviniente.request"
        [interviniente]="interviniente"
        (changeContinueStatus)="changeContinueStatusForms($event)"
      >
      </scf-direct-debit>
    </div>
    <scf-request-observations
      [mode]="mode"
      [observations]="request?.observations"
      [isAuto]="true"
      [request]="request"
      [state]="state"
      (changeContinueStatus)="changeContinueStatusForms($event)"
      (isFinishedLoading)="changeContinueLoadingStatus($event)"
    ></scf-request-observations>
    <div class="request__bottom--text" translate>request.agreementPersonalData</div>
    <div class="row" class="btnActions">
      <div class="btnLeft">
        <button id="previousStepThirdStepAutos" mat-flat-button color="accent" matStepperPrevious>
          {{ 'request.matStepperPrevious' | translate | uppercase }}
        </button>
        <button
          id="clearFieldsThirdStepAutos"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="clearFields()"
        >
          {{ 'request.buttonReset' | translate | uppercase }}
        </button>
      </div>
      <div class="btnRight">
        <button
          id="printContractButtonAutos"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('print')"
        >
          <mat-icon class="icon-ic_print"></mat-icon> {{ 'request.buttonPrintContract' | translate | uppercase }}
        </button>
        <button
          id="saveButtonThirdStepAutos"
          *ngIf="mode === 'new' || (mode === 'edit' && state?.id === '00')"
          mat-stroked-button
          color="accent"
          (click)="openDialogPassword('save')"
        >
          <mat-icon class="icon-ic_save"></mat-icon> {{ 'request.buttonSave' | translate | uppercase }}
        </button>
        <button
          id="sendButtonAutos"
          *ngIf="mode !== 'view'"
          mat-flat-button
          color="accent"
          (click)="openDialogPassword('send')"
          [disabled]="!enviarPeticion"
        >
          {{ 'request.buttonSend' | translate | uppercase }} <mat-icon class="icon-ic_send"></mat-icon>
        </button>
      </div>
    </div>
  </mat-step>
  <ng-template matStepperIcon="error">
    <mat-icon class="icon-ic_error_warnning"></mat-icon>
  </ng-template>
</mat-horizontal-stepper>
